import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  ClasseState,
  FetchClassesResponse,
  FetchClasseByIdResponse,
  FetchAllClassesResponse,
} from './types'
import {
  fetchClasseById,
  fetchClasses,
  createClasse,
  updateClasse,
  deleteClasse,
  suspendClasse,
  activateClasse,
  fetchAllClasses,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: ClasseState = {
  classeForEdit: null,
  classes: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const classeSlice = createSlice({
  name: 'classe',
  initialState,
  reducers: {
    resetClasses: (state: ClasseState) => {
      state.classes = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClasses.pending, (state: ClasseState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchClasses.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchClasses.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClassesResponse>) => {
        state.listLoading = false
        state.error = null
        const {classes, total, totalPages} = action.payload
        state.classes = classes
        state.total = total
        state.totalPages = totalPages
      }
    )
    builder.addCase(
      fetchAllClasses.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchAllClassesResponse>) => {
        state.listLoading = false
        state.error = null
        const {classes} = action.payload
        state.classes = classes
      }
    )
    builder.addCase(fetchAllClasses.pending, (state: ClasseState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchAllClasses.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(fetchClasseById.pending, (state: ClasseState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchClasseById.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchClasseById.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClasseByIdResponse>) => {
        state.classeForEdit = action.payload.classe
        state.listLoading = false
        state.error = null
        state.classeForEdit = action.payload.classe
      }
    )

    builder.addCase(createClasse.pending, (state: ClasseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createClasse.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createClasse.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClasseByIdResponse>) => {
        state.classeForEdit = action.payload.classe
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateClasse.pending, (state: ClasseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateClasse.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateClasse.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClasseByIdResponse>) => {
        state.classeForEdit = action.payload.classe
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteClasse.pending, (state: ClasseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteClasse.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteClasse.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClasseByIdResponse>) => {
        state.classeForEdit = action.payload.classe
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendClasse.pending, (state: ClasseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(suspendClasse.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      suspendClasse.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClasseByIdResponse>) => {
        state.classeForEdit = action.payload.classe
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateClasse.pending, (state: ClasseState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(activateClasse.rejected, (state: ClasseState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      activateClasse.fulfilled,
      (state: ClasseState, action: PayloadAction<FetchClasseByIdResponse>) => {
        state.classeForEdit = action.payload.classe
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default classeSlice.reducer
export const actions = classeSlice.actions
